import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import Content, { HTMLContent } from '../components/Content'

// eslint-disable-next-line
export const BlogPostTemplate = ({
  artist,
  content,
  contentComponent,
  description,
  category,
  tags,
  title,
  yearcreated,
  helmet,
}) => {
  const PostContent = contentComponent || Content

  return (
    <section>
      {helmet || ''}
      <div className='project--container'>
        <div>
          <h1>
            {title}
          </h1>
          {description}
        </div>
        <PostContent className='project--description' content={content} />
          {/* {tags && tags.length ? (
            <div style={{ marginTop: `4rem` }}>
              <h4>Tags</h4>
              <ul>
                {tags.map((tag) => (
                  <li key={tag + `tag`}>
                    <Link to={`/tags/${kebabCase(tag)}/`}>{tag}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ) : null} */}
      </div>
    </section>
  )
}

BlogPostTemplate.propTypes = {
  artist: PropTypes.string,
  content: PropTypes.node.isRequired,
  contentComponent: PropTypes.func,
  description: PropTypes.object,
  title: PropTypes.string,
  helmet: PropTypes.object,
  category: PropTypes.string,
  yearcreated: PropTypes.string,
}

const BlogPost = ({ data }) => {
  const { markdownRemark: post } = data
  console.log(post)

  return (
    <Layout>
      <BlogPostTemplate
        artist={post.frontmatter.artist}
        content={post.html}
        contentComponent={HTMLContent}
        description={post.frontmatter.description}
        yearcreated={post.frontmatter.yearcreated}
        helmet={
          <Helmet titleTemplate='%s | Blog'>
            <title>{`${post.frontmatter.title}`}</title>
            <meta
              name='description'
              content={`${post.frontmatter.description}`}
            />
          </Helmet>
        }
        tags={post.frontmatter.tags}
        title={post.frontmatter.title}
      />
    </Layout>
  )
}

BlogPost.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
}

export default BlogPost

export const pageQuery = graphql`
  query BlogPostByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        yearcreated(formatString: "YYYY")
        title
        artist
        category
        description
        tags
      }
    }
  }
`